// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"843f0876","422":"21f04564","701":"e31f887a"}[chunkId] + ".chunk.js";
};